import * as types from "../types/issues.types";
import moment from "moment";

const initialState = {
  initialData: [],
  initialLoading: false,
  initialPagination: [],
  initialFilter: {
    page: 1,
    limit: 10,
  },
  initialSingle: [],
};
const IssuesReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_ISSUES_DATA:
      return { ...state, initialData: action.payload };
    case types.SET_ISSUES_LOADING:
      return { ...state, initialLoading: action.payload };
    case types.SET_ISSUES_PAGINATION:
      return { ...state, initialPagination: action.payload };
    case types.SET_ISSUES_FILTER:
      return { ...state, initialFilter: action.payload };
    case types.SET_ISSUES_SINGLE:
      return { ...state, initialSingle: action.payload };
    case types.RESET_ISSUES_REDUCER:
      return { 
        ...state, 
        initialData: [],
        initialLoading: false,
        initialPagination: [],
        initialFilter: {
          page: 1,
          limit: 10,
        },
        initialSingle: [],
      };
    default:
      return state;
  }
};
export default IssuesReducer;
